export const btnFuncLoad = (item) => {
    item.classList.add('load', 'disabled');
};